import React, { Fragment, useEffect } from "react";
import MetaTags from "react-meta-tags";
import LayoutTwo from "../layouts/LayoutTwo";
import Breadcrumb from "../components/breadcrumbs/Breadcrumb";
import TeamContent from "../containers/teams/TeamContent";
import ReactGA from 'react-ga';

const Team = () => {
  useEffect(()=>{
    ReactGA.pageview('Team')
  },[])
  return (
    <Fragment>
      <MetaTags>
        <title>MetaBlock Technologies | Team</title>
        <meta
          name="description"
          content="Team page of React JS Crypto Currency Template."
        />
      </MetaTags>
      <LayoutTwo theme="white">
        {/* breadcrumb */}
        <Breadcrumb title="OUR TEAM" />
        {/* team content */}
        <TeamContent />
      </LayoutTwo>
    </Fragment>
  );
};

export default Team;
